/*
* Association construction information form view for authenticated users
*/

import * as _ from 'lodash';
import * as React from 'react';

import * as KendoWrappers from '../../common/kendoforms/componentwrappers';
import * as DetailFormCommon from './common';

export const AssociationDetailsNotes = ({
    appText,
    handleFormInputChange,
    handleSubmitForm,
    handleSaveChanges,
    numFormChanges,
    formData,
    defaultInputProps,
    sectionTitle,
    ...rest }) => {
    if (!appText || !formData) { return (<div />); }

    let inputPropsFullWidthTextDebounced = _.merge({}, defaultInputProps, {
        handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-75',
        colLabelXs: 5,
        colInputXs: 7,
    });

    let inputPropsFullWidthTextAreaDebounced = _.merge({}, defaultInputProps, {
        handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
        colLabelXs: 12,
        colInputXs: 12,
    });

    let inputProps = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
        colLabelXs: 5,
        colInputXs: 7,
    });

    // console.log('formData.notes: ', formData.notes);
    // console.log('formData.sections.notes: ', formData.sections);
    return (
        <DetailFormCommon.AssociationDetailFormSection title={sectionTitle}>
            <div>
                <div>
                    <KendoWrappers.KendoTextareaDebounced
                        name="notes"
                        label={appText('notes-add')}
                        value={formData.notes}
                        {...inputPropsFullWidthTextAreaDebounced}
                    />
                </div>
            </div>
        </DetailFormCommon.AssociationDetailFormSection>
    );
};



// WEBPACK FOOTER //
// ./src/association/detail-form/association-details-notes.tsx